import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { infoSelector } from 'selectors/indicator';
import tableSelector from 'selectors/indicator/table';
import { actionToggleFilter } from 'actions';
import getViewProperties from 'services/getViewProperties';
import classNames from 'classnames';

// Components
import IndicatorHeader from 'components/indicatorHeader';
import CountyTableView from 'components/countyTableView';
import table from 'components/table';
import TableRowChart from 'components/tableRowChart';
import TableControls from 'components/tableControls';
import Copyright from 'components/copyright';
import TextBlock from 'components/textBlock';

import styles from './tableView.scss';

const Table = table(TableRowChart);
const UsTable = table(TableRowChart);

class TableView extends React.Component {
  componentWillMount() {
    const {
      uiFlag,
      toggleFilter,
      tableFilter,
      location: { search },
    } = this.props;

    if (!uiFlag && !tableFilter && '' !== search) {
      toggleFilter();
    }
  }

  render() {
    const {
      columns,
      info: {
        sources = '',
      },
      location: {
        pathname,
      },
      rowData,
      match: {
        params: {
          category,
          renderType,
        },
      },
      shortTitle,
    } = this.props;

    const isTwoCol = 2 === columns.length;

    const {
      isEmbedded,
      isExporting,
      isMinimalView,
    } = getViewProperties(renderType);

    return (
      <div>
        <IndicatorHeader />
        <section className={styles.section}>
          {!isMinimalView &&
            <TableControls />
          }
          <h3 className={styles.title}>{shortTitle}</h3>
          <div
            className={classNames(
              styles.table,
              { [styles.minimalTable]: isMinimalView }
            )}
          >
            {'international' === category && (
              <Route
                path="/:renderType?/:category/indicator/:indicatorName/table"
                render={() =>
                  (<Table
                    columns={columns}
                    renderType={renderType}
                    rowData={rowData}
                    isTwoCol={isTwoCol}
                  />)}
                exact
              />
            )}
            {'usdata' === category && (
              <Switch>
                <Route
                  path="/:renderType?/:category/indicator/:indicatorName/table/:state/counties"
                  component={CountyTableView}
                  exact
                />
                <Route
                  path="/:renderType?/:category/indicator/:indicatorName/table"
                  render={() => (
                    <div>
                      {!isMinimalView &&
                        <div className={styles.helpText}>
                          Click on the state name to show/hide county-level
                          data.
                        </div>
                      }
                      <UsTable
                        columns={columns}
                        renderType={renderType}
                        rowData={rowData}
                        isTwoCol={isTwoCol}
                      />
                    </div>)}
                  exact
                />
              </Switch>
            )}
          </div>
          {isMinimalView && sources &&
            <TextBlock
              title="Sources"
              text={sources}
            />
          }
          <Copyright
            isEmbedded={isEmbedded}
            isExporting={isExporting}
            originalPath={pathname}
          />
        </section>
      </div>
    );
  }
}

TableView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      renderType: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      idx: PropTypes.number.isRequired,
      colId: PropTypes.string.isRequired,
      label: PropTypes.string,
      fixed: PropTypes.oneOf(['left', 'right']),
    })
  ).isRequired,
  shortTitle: PropTypes.string.isRequired,
  uiFlag: PropTypes.bool.isRequired,
  tableFilter: PropTypes.bool.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  rowData: PropTypes.arrayOf(
    PropTypes.shape({
      rowId: PropTypes.string.isRequired,
      pin: PropTypes.bool.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          idx: PropTypes.number.isRequired,
          fixed: PropTypes.oneOf(['left', 'right']),
          align: PropTypes.oneOf(['right', 'center', 'left']),
          formattedValue: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  info: PropTypes.shape({
    sources: PropTypes.string,
  }).isRequired,
};

const makeMapStateToProps = (state) => ({
  ...tableSelector(
    state,
    {
      pinValue: 'usdata' === state.data.indicator.dataView ? 'United States' : 'World',
      tableFilter: Boolean(state.data.tableFilter),
      uiFlag: Boolean(state.data.uiFlag),
    }
  ),
  info: infoSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleFilter: () => dispatch(actionToggleFilter()),
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(withRouter(TableView));



// WEBPACK FOOTER //
// ./app/components/tableView/index.js